import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    $('#welcomeMessageModal').modal('show');
  }

  dismissDialog(event) {
    if ($("#showWelcomeMessageAgain").prop("checked") == true) {
      $.ajax({
        url: `/organization/users/${$(event.target).data("id")}`,
        method: "PATCH",
        data: {"user": {"show_welcome_message": false}},
        dataType: 'json',
        success: (result, status, jqXHR) => {
          console.log(result)
        },
        error: (jqXHR, textStatus, errorThrown) => {
        }
      });
    }
  }
}